import axios from "axios";
import keycloak from "../keycloak";
const { REACT_APP_EXTRANET_URL, REACT_APP_APIM_PASS } = process.env;

axios.defaults.baseURL = REACT_APP_EXTRANET_URL;

export const setHeaderToken = (): void => {
  const token = localStorage.getItem("keycloak-token");
  axios.defaults.headers.common["x-api-key"] = REACT_APP_APIM_PASS;
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

export default (): void => {
  setHeaderToken();
  axios.interceptors.response.use(
    (result) => result,
    (err) => {
      if (err.message.includes("401")) {
        keycloak.updateToken(3600);
      }
      return Promise.reject(err);
    }
  );
};
